// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dimension-box {
  background: var(--color-light-blue) linear-gradient(0deg, rgb(255, 255, 255) 0%, #FFFFFF 100%);
  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);
  border-radius: 0.375rem;
  margin-right: 0.333rem;
  height: 4.6rem;
  min-width: 9rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.dimension-box.highlightPosition {
  background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
}
.dimension-box .name-title {
  display: flex;
  align-items: center;
}
.dimension-box .name-title .position-name {
  color: var(--color-primary-blue);
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
  font-size: 0.85rem;
}
.dimension-box .name-title .check_icon {
  margin-right: 0.2rem;
  width: 1rem;
  height: 1.083rem;
}
.dimension-box .amount {
  display: flex;
  align-items: center;
  position: relative;
  height: 1rem;
}
.dimension-box .amount .icon {
  margin-right: 0.333rem;
  height: 0.742rem;
  width: 0.908rem;
}
.dimension-box .amount .countries-amount {
  font-size: 0.75rem;
  color: var(--color-primary-blue);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dimension-box .amount .flag {
  height: 1rem;
  width: 1rem;
  box-shadow: 0 0.083rem 0 0 rgba(0, 0, 0, 0.24);
  border-radius: 50%;
  position: absolute;
  right: 0;
  bottom: 10%;
  border: 1px solid var(--color-primary-blue);
}`, "",{"version":3,"sources":["webpack://./src/app/game/overview/dimension-box/dimension-box.component.scss"],"names":[],"mappings":"AAAA;EACE,8FAAA;EACA,yCAAA;EACA,uBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AACF;AACE;EACE,yHAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;AAAJ;AAEI;EACE,gCAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAAN;AAGI;EACE,oBAAA;EACA,WAAA;EACA,gBAAA;AADN;AAKE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAHJ;AAKI;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;AAHN;AAMI;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJN;AAQI;EACE,YAAA;EACA,WAAA;EACA,8CAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2CAAA;AANN","sourcesContent":[".dimension-box {\n  background: var(--color-light-blue) linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, #FFFFFF 100%);\n  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);\n  border-radius: 0.375rem;\n  margin-right: 0.333rem;\n  height: 4.6rem;\n  min-width: 9rem;\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  &.highlightPosition {\n    background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n  }\n\n  .name-title {\n    display: flex;\n    align-items: center;\n\n    .position-name {\n      color: var(--color-primary-blue);\n      overflow: hidden;\n      text-overflow: ellipsis;\n      font-weight: bold;\n      font-size: 0.85rem;\n    }\n\n    .check_icon {\n      margin-right: 0.2rem;\n      width: 1rem;\n      height: 1.083rem;\n    }\n  }\n\n  .amount {\n    display: flex;\n    align-items: center;\n    position: relative;\n    height: 1rem;\n\n    .icon {\n      margin-right: 0.333rem;\n      height: 0.742rem;\n      width: 0.908rem;\n    }\n\n    .countries-amount {\n      font-size: 0.75rem;\n      color: var(--color-primary-blue);\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      //width: 55%;\n    }\n\n    .flag {\n      height: 1rem;\n      width: 1rem;\n      box-shadow: 0 0.083rem 0 0 rgba(0, 0, 0, 0.24);\n      border-radius: 50%;\n      position: absolute;\n      right: 0;\n      bottom: 10%;\n      border: 1px solid var(--color-primary-blue);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
